import React from 'react';
import PropTypes from 'prop-types';

import TextWithAccordionListItemsCard from '../../../components/TextWithAccordionListItemsCard';
import BannerStyleCard from '../../../components/BannerStyleCard';

import './index.scss';

const HelpAndFaqTab = ({ data }) => {
  const { helpAndFaq } = data.uiData;
  return (
    <div className='help-and-faq-tab'>
      <TextWithAccordionListItemsCard
        textBlock={{
          eyebrow: helpAndFaq.eyebrow,
          title: helpAndFaq.title,
          text: helpAndFaq.text,
        }}
        accordionListItems={helpAndFaq.faqs}
      />
      <BannerStyleCard
        textBlockItems={{
          eyebrow: helpAndFaq.bannerEyebrow,
          title: helpAndFaq.bannerTitle,
          price: helpAndFaq.bannerPrice,
        }}
        description={helpAndFaq.bannerDescription}
        buttonText={helpAndFaq.bannerButtonText}
        buttonUrl={helpAndFaq.bannerButtonUrl}
      />
    </div>
  );
};

HelpAndFaqTab.propTypes = {
  data: PropTypes.object,
};

export default HelpAndFaqTab;
